export const applicationId = import.meta.graphCommerce.algoliaApplicationId ?? ''
export const searchOnlyApiKey = import.meta.graphCommerce.algoliaSearchOnlyApiKey ?? ''
